"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShopperBaskets = void 0;
var _ocapiShopperBaskets = require("./ocapi-shopper-baskets");
var sdk = _interopRequireWildcard(require("commerce-sdk-isomorphic"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// This class is an extension to OcapiShopperBaskets class to include basket functions implemented in SCAPI.
// Current implementation has ShopperBaskets interactiing with OCAPI which misses new functions implemented in newer SCAPI releases.
class ShopperBaskets extends _ocapiShopperBaskets.OcapiShopperBaskets {
  // @ts-ignore

  constructor(config) {
    super(config);
    this.shopperBasketsClient = new sdk.ShopperBaskets(config);
  }
  mergeBasket(args) {
    return this.shopperBasketsClient.mergeBasket(args);
  }
}
exports.ShopperBaskets = ShopperBaskets;